import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    base_imponible: { label: i18n.t('invoices.taxable_base'), value: '' },
    clase: { label: i18n.t('invoices.invoices_issuing.clase'), value: '' },
    tipo: { label: i18n.t('invoices.tipo_factura'), value: '' },
    cuota: { label: i18n.t('invoices.invoices_issuing.tax_cuota'), value: '', type: 'number' },
    total_factura: { label: i18n.t('app.total'), value: '', type: 'number' },
  } 
}
const getTranslateColumns = () => [
  { field: 'BaseImponible', title: i18n.t('invoices.taxable_base'), format: 'currency_8', cell: 'numberTemplate', columnMenu: 'myTemplateNoCol', locked: false },
  { field: 'Clase', title: i18n.t('invoices.invoices_issuing.clase'), format: 'TIPOS_CODIGO_IMPUESTO', cell: 'enumTemplate', columnMenu: 'myTemplateNoCol', locked: false },
  { field: 'Tipo', title: i18n.t('app.type'), format: 'percent_decimal', cell: 'numberTemplate', columnMenu: 'myTemplateNoCol', locked: false },
  { field: 'Cuota', title: i18n.t('invoices.invoices_issuing.tax_cuota'), format: 'currency_8', cell: 'numberTemplate', columnMenu: 'myTemplateNoCol', locked: false },
  { field: 'Total', title: i18n.t('app.total'), format: 'currency_8', cell: 'numberTemplate', columnMenu: 'myTemplateNoCol', locked: false },
]
const getDefaultForm = () => ({
  total_neto: '',
  total_impuestos: '',
  total_bruto: '',
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const customState = getDefaultState()
const customGetters = { 
  form: state => state.form,
  impuestos: (state, getters, rootState, rootGetters) => {
    const invoiceLines = rootGetters['invoicesIssuing/form']?.invoiceLines ?? []
    return invoiceLines.map(line => ({
      id: `${line.taxType} - ${line.taxRate}`,
      BaseImponible: line.total,
      Clase: line.taxType,
      Tipo: line.taxRate,
      Cuota: line.cuotaImpuesto,
      Total: line.totalConImpuesto
    })).reduce((acc, line) => {
      const aux = acc.find(tax => tax.id === line.id)
      if (aux) {
        aux.BaseImponible += line.BaseImponible
        aux.Cuota += line.Cuota
        aux.Total += line.Total
      } else {
        acc.push(line)
      }
      return acc
    }, [])
  }
}
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
const mystore = parent({ getTranslateColumns, customState, customGetters, customActions, navigate: false, namespaced: true, getTranslateMasterFilters })

export default mystore
